module["exports"] = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NS",
  "NU",
  "NT",
  "ON",
  "PE",
  "QC",
  "SK",
  "YK"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr_CA/address/state_abbr.js
// module id = 845
// module chunks = 0